"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fleet = exports.FleetItem = exports.SyncRo = exports.HydroTapBridge = exports.Blackbox = exports.Gbfc = exports.Pelican2 = void 0;
const effect_1 = require("effect");
const schema_1 = require("../../../schema");
const device_1 = require("../../device");
const NAMESPACE = 'Culligan.Api.Device.Fleet';
const getFleetFields = (deviceFields) => {
    return {
        manufacturingSerialNumber: effect_1.Schema.NullOr(schema_1.PrintString),
        ...effect_1.Struct.pick(deviceFields, 'id', 'model', 'assetTag', 'detectedLocation', 'tenantId', 'installationAddress', 'providedLocation', 'vendor', 'businessUnit', 'alarms', 'errors', 'state', 'connectionStatus'),
    };
};
class Pelican2 extends effect_1.Schema.Class(`${NAMESPACE}.Pelican2`)(getFleetFields(device_1.Class.Pelican2.Pelican2.fields), { identifier: `${NAMESPACE}.Pelican2` }) {
    static Device = device_1.Class.Pelican2.Pelican2;
}
exports.Pelican2 = Pelican2;
class Gbfc extends effect_1.Schema.Class(`${NAMESPACE}.Gbfc`)(getFleetFields(device_1.Class.Gbfc.Gbfc.fields), { identifier: `${NAMESPACE}.Gbfc` }) {
    static Device = device_1.Class.Gbfc.Gbfc;
}
exports.Gbfc = Gbfc;
class Blackbox extends effect_1.Schema.Class(`${NAMESPACE}.Blackbox`)(getFleetFields(device_1.Class.Blackbox.Blackbox.fields), { identifier: `${NAMESPACE}.Blackbox` }) {
    static Device = device_1.Class.Blackbox.Blackbox;
}
exports.Blackbox = Blackbox;
class HydroTapBridge extends effect_1.Schema.Class(`${NAMESPACE}.HydroTapBridge`)(getFleetFields(device_1.Class.HydroTapBridge.HydroTapBridge.fields), { identifier: `${NAMESPACE}.HydroTapBridge` }) {
    static Device = device_1.Class.HydroTapBridge.HydroTapBridge;
}
exports.HydroTapBridge = HydroTapBridge;
class SyncRo extends effect_1.Schema.Class(`${NAMESPACE}.SyncRo`)(getFleetFields(device_1.Class.SyncRo.SyncRo.fields), { identifier: `${NAMESPACE}.SyncRo` }) {
    static Device = device_1.Class.SyncRo.SyncRo;
}
exports.SyncRo = SyncRo;
exports.FleetItem = effect_1.Schema.Union(Pelican2, Gbfc, Blackbox, HydroTapBridge, SyncRo).annotations({
    identifier: `${NAMESPACE}.FleetItem`,
});
exports.Fleet = effect_1.Schema.Array(exports.FleetItem).annotations({
    identifier: `${NAMESPACE}.Fleet`,
});
//# sourceMappingURL=fleet.js.map